var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 34,
    viewBox: "0 0 45 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 34,
    rx: 6,
    fill: "#F5EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5L32.8923 11V23L22.5 29L12.1077 23V11L22.5 5Z",
    fill: "#7933FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19.635L25.59 21.5L24.77 17.985L27.5 15.62L23.905 15.31L22.5 12L21.095 15.31L17.5 15.62L20.225 17.985L19.41 21.5L22.5 19.635Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature4);
export default __webpack_public_path__ + "static/media/feature4.50f982fbc56501fe3bb83599072cda57.svg";
export { ForwardRef as ReactComponent };